import { Button, Col, Typography, useTheme } from "@commonlibs";
import { ProgramDto } from "common/models";
import useTranslate from "ui/locale/hooks/useTranslate";
import Link from "ui/router/components/Link/Link";
import { config } from "common/config";
import BaseCard from "ui/common/components/feedback/BaseCard/BaseCard";
import ProgramImage from "../ProgramImage/ProgramImage";

export interface ProgramDetailsProps {
    program?: ProgramDto;
}

function ProgramDetails({ program, ...rest }: ProgramDetailsProps) {
    const translate = useTranslate();
    const { spacing } = useTheme();

    return (
        <Col gap={spacing[22]} justifyContent="space-between" flex={1} {...rest}>
            <Col gap={spacing[4]}>
                <BaseCard color="lavender">
                    <Col alignItems="center" gap={spacing["2"]}>
                        <ProgramImage
                            src={program?.logo || ""}
                            alt={`${program?.name}-img`}
                            fallback={config.fallbackImages.programImage}
                        />
                        <Typography variant="body2Strong" color="text" numberOfLines={1}>
                            {program?.name}
                        </Typography>
                    </Col>
                </BaseCard>
                <Typography variant="body3Light" color="black">
                    {program?.description}
                </Typography>
            </Col>
            {program?.url && (
                <Link to={program.url}>
                    <Button variant="primary" fullWidth>
                        {translate("viewMoreInformation")}
                    </Button>
                </Link>
            )}
        </Col>
    );
}

export default ProgramDetails;
